import React, { useContext, useEffect, useState } from 'react';
import { FC, ReactNode } from 'react';
import { Box, makeStyles } from '@material-ui/core';
import NavLeft from './NavLeft';
import NavRight from './NavRight';
import NavTop from './NavTop';
import { AuthContext, AuthStatus } from 'src/contexts/authContext';
import GuestHeader from 'src/views/workspace/components/layouts/GuestHeader';
import { useHistory } from 'react-router';

interface EditorLayoutProps {
  children?: ReactNode;
}

const useStyles = makeStyles(() => ({
  root: {
    width: '100%',
    minWidth: 1400,
    height: '100%',
    display: 'flex',
    flexDirection: 'column',

    backgroundColor: '#e5e5e5'
  },
  container: {
    height: 'calc(100vh - 3rem)',
    minWidth: 1400,
    width: '100%',
    display: 'flex',
    flexDirection: 'row'
  },
  templateWrapper: {
    width: '100%',
    minWidth: '42rem',
    height: 'calc(100vh - 3rem)',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',

    overflowX: 'auto',
    overflowY: 'auto'
  },

  sideWrapper: {
    width: '22rem',
    minWidth: '22rem',
    display: 'flex'
  },

  guestHeaderWrapper: {
    padding: '0 15px',
    background: 'black',
    width: '100%',
    minWidth: 1400
  },
  guestHeader: {
    background: 'black',
    color: 'white',
    border: 'white',
    buttonColor: 'white',
    buttonBackground: '#333333'
  }
}));

const EditorLayout: FC<EditorLayoutProps> = ({ children }) => {
  const classes = useStyles();
  const history = useHistory();
  const [guestMode, setGuestMode] = useState(false);
  const { authStatus } = useContext(AuthContext);

  const onClickLogoGuest = () => {
    history.push('/workspace/templates');
  };

  useEffect(() => {
    if (authStatus !== AuthStatus.SignedIn) {
      setGuestMode(true);
    } else {
      setGuestMode(false);
    }
  }, [authStatus]);

  return (
    <>
      {guestMode && (
        <div className={classes.guestHeaderWrapper}>
          <GuestHeader
            onClickLogoGuest={onClickLogoGuest}
            style={{
              background: 'black',
              color: 'white',
              border: 'white',
              buttonColor: 'white',
              buttonBackground: '#333333'
            }}
          />
        </div>
      )}
      <div className={classes.root}>
        <NavTop />
        <div className={classes.container}>
          <Box className={classes.sideWrapper}>
            <NavLeft />
          </Box>
          <Box className={classes.templateWrapper}>{children}</Box>
          <Box className={classes.sideWrapper}>
            <NavRight />
          </Box>
        </div>
      </div>
    </>
  );
};

export default EditorLayout;
